// src/LoginPage.js
import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Link, useNavigate } from 'react-router-dom';

// Stili base per centrare il form
const loginStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f2f2f2'
};
const formStyles = {
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    width: '300px',
    textAlign: 'center'
};
const inputStyles = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    boxSizing: 'border-box',
    borderRadius: '4px',
    border: '1px solid #ccc'
};
const buttonStyles = {
    width: '100%',
    padding: '10px',
    border: 'none',
    backgroundColor: '#d5a6bd',
    color: 'white',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px'
};
const errorStyles = {
    color: 'red',
    marginTop: '10px'
};
const linkStyles = {
    marginTop: '20px',
    fontSize: '0.9rem'
};


function LoginPage({ onLoginSuccess }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate(); // 🎯 FIX: Aggiunto l'hook per il redirect

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        const auth = getAuth();
        
        // 🎯 FIX EMAIL INTELLIGENTE: Se l'utente digita già un'email, la usiamo, 
        // altrimenti aggiungiamo @gmail.com (per i vecchi dipendenti)
        let emailToUse = username.trim().toLowerCase();
        if (!emailToUse.includes('@')) {
            emailToUse = `${emailToUse}@gmail.com`;
        }

        try {
            await signInWithEmailAndPassword(auth, emailToUse, password);
            navigate('/', { replace: true }); // 🎯 FIX REDIRECT: Forza l'utente ad atterrare sulla Dashboard
        } catch (err) {
            setError('Credenziali non valide. Riprova.');
            console.error("Errore di login:", err);
        }
    };

    return (
        <div style={loginStyles}>
            <form onSubmit={handleLogin} style={formStyles}>
                <h2>Accesso Turni</h2>
                <input
                    type="text"
                    placeholder="Nome utente"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    style={inputStyles}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={inputStyles}
                    required
                />
                <button type="submit" style={buttonStyles}>Accedi</button>
                {error && <p style={errorStyles}>{error}</p>}
                {/* --- 2. AGGIUNGI QUESTO BLOCCO --- */}
                <p style={linkStyles}>
                    Non hai un account? 
                    <Link to="/register"> Registra un nuovo centro</Link>
                </p>
                {/* --- FINE BLOCCO --- */}
            </form>
        </div>
    );
}

export default LoginPage;